import styled from "styled-components";

export const ContainerLayout = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    background-color: ${({theme}) => theme?.header?.background};
    grid-area: header;
    display: flex;
    color: ${({ theme }) => theme.color};
    border-bottom: ${({ theme }) => theme.menu.main == "#112233" ? "1px solid #223547" : "1px solid #ccc" };
`

export const LayoutLogo = styled.section`
  display: flex;
  justify-content: left;
  padding-left: 5px;

  img {
   width: 120px;
    filter: ${({ theme }) => theme.name == "dark" ? "brightness(100)" : "auto"};
  }

  @media (max-width: 480px) {
    img {
      min-width: 120px;
    }
  }
`

export const Cliente = styled.section`
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 0 0 10px;
    gap: 2em;

    div {
        text-align: center;
        margin-right: 0.5em;
        color: ${({ theme }) => theme.header.text};
        h2{
            font-size: 14px;
        }
        h1{
            font-size: 20px;
        }
    }
`
